export const API_URL = 'https://forkify-api.herokuapp.com/api/v2/recipes/';
export const TIMEOUT_SEC = 10;
export const KEY = 'f9a68cc1-a413-4089-baec-d3fd9d8a8e0f';
export const RES_PER_PAGE = '10';
export const MODAL_CLOSE_SEC = 2.5;
